import React, { useState } from "react";
import { Outlet, Link, NavLink } from "react-router-dom";
import Metalogo from "../Metalogo";
import "../assets/Home.css";

function Layout({ items }) {
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const itemsValues = Object.values(items);
  // eslint-disable-next-line
  let customizations = Object.keys(itemsValues[0].customizations);
  const mapIndex = () =>
    itemsValues.map(
      (item) => (customizations = Object.keys(item.customizations))
    );
  const cust = Object.entries(mapIndex());

  return (
    <div className="App">
      <div className="header">
        <Metalogo />
        <div>
          <nav className="nav">
            <button
              id="mySidenav"
              className="menuIcon"
              onClick={() => {
                setIsNavExpanded(!isNavExpanded);
              }}
            >
              <div className="bar"></div>
              <div className="bar"></div>
              <div className="bar"></div>
            </button>
            <div className={isNavExpanded ? "navLinks expanded" : "navLinks"}>
              <ul>
                <li>
                  <NavLink to="/" target="_top" activeclassnav="active">
                    Home
                  </NavLink>
                </li>
                <li id="custNav">
                  <NavLink target="_top" to="/customizations">
                    Customizations
                  </NavLink>
                  <ul className="drop-down-content">
                    {itemsValues.map((item, index) => (
                      <div key={index}>
                        <li className="nested-nav">
                          <img
                            src={`${item.icon}`}
                            title="cust-img"
                            alt={item.title}
                            style={{
                              width: "1.2em",
                              height: "1.2em",
                              objectFit: "contain",
                            }}
                          />
                          <Link
                            to={`/customization/${item.slug}/${cust[index][1][0]}`}
                            style={{ paddingLeft: ".2em", paddingTop: ".5em" }}
                          >
                            {item.title}
                          </Link>
                        </li>
                      </div>
                    ))}
                  </ul>
                </li>
                <li className="nested-nav drop-down">
                  <Link to="#">Resources</Link>
                  <ul className="drop-down-content" id="resources">
                    <li>
                      <a
                        className="nested-nav"
                        target="new"
                        href="https://www.youtube.com/channel/UCYEYZaEcvGs_UeYUV0dEimA/playlists"
                      >
                        META YouTube Channel
                      </a>
                    </li>
                    <li>
                      <a
                        className="nested-nav"
                        target="new"
                        href="https://metaitc.sharepoint.com/sites/PowerSchool/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2FPowerSchool%2FShared%20Documents%2FGeneral%2FEND%20USERS%2FCUSTOMIZATION%20CATALOG%2FRelease%20Notes&p=true&originalPath=aHR0cHM6Ly9tZXRhaXRjLnNoYXJlcG9pbnQuY29tLzpmOi9zL1Bvd2VyU2Nob29sL0VpLVlqRWRmamF0QnVoOHhSdDhWRk5JQjFGbTRxeWd4MHVXR0pMdGNnSXdsWWc%5FcnRpbWU9UXQ5aXEzaXAxMGc"
                      >
                        Release Notes
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link
                    className="btn_request_trial"
                    target="_top"
                    style={{
                      color: "white",
                      padding: ".5em",
                      margin: "0 .5em 0 1em",
                    }}
                    to="/request_trial_form"
                  >
                    Request 30 Day Trial
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
export default Layout;
